export default "<span>{{ frontAmount | number:format }}</span>\n\n";